import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import styled from '@emotion/styled';
import theme from '../../theme';

export const SpanError = styled('span')(({ theme }) => ({
  marginLeft: '6px',
  color: theme.palette.error.main
}))

export const TextFieldCleanStyle = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    padding: '8px',
    backgroundColor: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}))

export const TextFieldLarge = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    height: '40px',
    padding: '6px 10px',
    borderRadius: '16px',
    backgroundColor: '#fff'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.w600,
    transition: 'border .5s',
  },
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.w400,
      borderWidth: '2px',
    }
  },
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.w600,
      borderWidth: '2px',
    }
  },
}))